import common_translations from "../common.json";
import app from "./app.json";
import blue from "./blue.translation.json";
import checkout from "./checkout.json";
import exchange from "./exchange.json";
import fintech from "./fintech.json";
import flights from "./flights.json";
import hopper from "./hopper.translation.json";
import hotels from "./hotels.json";
import marriott_provided from "./marriott.provided.json";
import marriott from "./marriott.translation.json";
import trips from "./trips.json";
import uber from "./uber.translation.json";
import ui from "./ui.json";
import wallet from "./wallet.json";

const bundle = {
  ...common_translations,
  ...app,
  ...flights,
  ...hotels,
  ...ui,
  ...checkout,
  ...trips,
  ...fintech,
  ...exchange,
  ...wallet,
};
export default bundle;

export const es_defaultTranslations = bundle;

export const es_hopperTranslations = hopper;

export const es_blueTranslations = blue;

export const es_uberTranslations = uber;

export const es_marriottTranslations = marriott;

export const es_marriottProvidedTranslations = marriott_provided;
